var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1.46469C24 0.791274 23.4541 0.245361 22.7807 0.245361H8.70951C7.9976 0.245361 7.32124 0.556444 6.85794 1.09696L0.587092 8.41295C-0.195697 9.32621 -0.195697 10.6738 0.587092 11.5871L6.85794 18.9031C7.32124 19.4436 7.9976 19.7547 8.70951 19.7547H22.7807C23.4541 19.7547 24 19.2087 24 18.5353V1.46469ZM21.5613 2.68402V17.316H8.70951L2.43866 10L8.70951 2.68402H21.5613Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7655 5.47982C19.2417 5.956 19.2417 6.72804 18.7655 7.20421L11.4496 14.5202C10.9734 14.9964 10.2013 14.9964 9.72516 14.5202C9.24898 14.044 9.24898 13.272 9.72516 12.7958L17.0411 5.47982C17.5173 5.00364 18.2894 5.00364 18.7655 5.47982Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72516 5.47982C10.2013 5.00364 10.9734 5.00364 11.4496 5.47982L18.7655 12.7958C19.2417 13.272 19.2417 14.044 18.7655 14.5202C18.2894 14.9964 17.5173 14.9964 17.0411 14.5202L9.72516 7.20421C9.24898 6.72804 9.24898 5.956 9.72516 5.47982Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectIcon);
export default __webpack_public_path__ + "static/media/correct-icon.d98611e4e4405537f283dedbe226826a.svg";
export { ForwardRef as ReactComponent };